import { Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
// import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LaCheckboxGroupOptionInterface } from '../checkbox-group/la-checkbox-group-option.interface';
import { LaRadioGroupOptionInterface } from '../radio-group/la-radio-group-option.interface';

/**
 * @group Filter Buttons
 * @component Filter Button
 * @description Filter Button
 */
@Component({
  selector: 'la-filter-button',
  template: `
    <button type="button" class="la-radio-button" (click)="onClick()"
            [class.la-radio-button--active]="option.isActive"
            [class.la-radio-button--disable]="isDisabled"
            [disabled]="isDisabled">
      <span class="la-radio-button__icon" [class.la-radio-button__icon--hide]="!option.isActive">
        <la-icon [name]="'remove'" [color]="'white'" [size]="'sm'"></la-icon>
      </span>
      <la-text [kind]="'title-3'">
        <ng-content></ng-content>
      </la-text>
    </button>
  `,
  styles: [`
    .la-radio-button{display:inline-flex;height:32px;color:rgba(3,20,34,.55);background-color:#fff;border-radius:16px;border:1px solid rgba(3,20,34,.15);cursor:pointer;padding:0 12px;text-align:center;line-height:3.4px}.la-radio-button:hover:enabled{color:#23be9e;border:1px solid #23be9e;background-color:#fff}.la-radio-button--active{color:#fff!important;background-color:#23be9e!important;border:1px solid #23be9e}.la-radio-button--disable{color:rgba(3,20,34,.15);background-color:#fff;border:1px solid rgba(3,20,34,.15);cursor:not-allowed}.la-radio-button__icon{margin-right:2px;margin-left:-3px}.la-radio-button__icon--hide{display:none}button:focus{outline:none}
  `],
  // providers: [{
  //   provide: NG_VALUE_ACCESSOR,
  //   useExisting: forwardRef(() => LaFilterButtonComponent),
  //   multi: true
  // }],
  encapsulation: ViewEncapsulation.None
})
export class LaFilterButtonComponent {
  @Input() option: LaCheckboxGroupOptionInterface | LaRadioGroupOptionInterface = {label: '', value: '', isActive: false};
  @Output() onSelected: EventEmitter<any> = new EventEmitter();
  @Output() onDeselected: EventEmitter<any> = new EventEmitter();

  private _isDisabled = false;
  private _value = '';
  private _selectedValue = '';
  propagateChange: Function;

  @Input()
  get isActive() {
    return this.option.isActive;
  }
  onChange: any = Function.prototype;
  onTouched: any = Function.prototype;

  set isActive(newActive) {
    this.option.isActive = newActive;
  }

  onClick(): void {
    if (this.isDisabled) {
      return;
    }
    this.isActive = !this.isActive;
    if (this.isActive) {
      this._selectedValue = this.value;
      this.onSelected.next(this._value);
    } else {
      this._selectedValue = '';
      this.onDeselected.next(this._value);
    }

    if (this.propagateChange) {
      this.propagateChange(this._selectedValue);
    }
  }

  // [isDisabled]
  get isDisabled(): boolean {
    return this._isDisabled;
  }

  /**
   * true - to make button disabled. false - by default
   */
  @Input()
  set isDisabled(value: boolean) {
    this._isDisabled = value;
  }

  // writeValue(value: any): void {
  // this._selectedValue = value;
  //     // if (value === this.value) {
  //     //   this.isActive = true;
  //     // }
  // this.registerOnChange(this._selectedValue)
  // }

  // registerOnChange(fn: any): void {
  //   this.propagateChange = fn;
  // }
  //
  // registerOnTouched(fn: any): void {
  // }

  @Input()
  set value(value: string) {
    this._value = value;
  }

  get value(): string {
    return this._value;
  }
}
